import moment from 'moment'
// import ft from '../featureToggle'

export default {
  getRatings (VueApp, conId, callback) {
    let ratings = VueApp.$store.state.consumer.ratings
    let pageSize = ratings.perPage
    let page = ratings.currentPage

    VueApp.$sdk.get('/consumer/' + conId + '/reviews', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: pageSize,
      pageNum: page + 1
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('consumer/setRatingsCurrentPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('consumer/setRatingsIsMax', true)
        }

        if (res.list.length) {
          let rating = res.list
          for (let i = 0; i < res.list.length; i++) {
            VueApp.$store.commit('consumer/addRatings', {
              id: rating[i].id,
              // date: moment(rating[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, true)),
              date: moment(rating[i].created, 'YYYY-MM-DD@HH:mm:ss').format('MM/DD/YYYY HH:mm:ss'),
              provName: rating[i].provider.businessName,
              provId: rating[i].provider.id,
              rsvpId: rating[i].rsvpId,
              value: rating[i].value,
              message: rating[i].message
            })
          }
        }
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/consumer/ratings.js